/* eslint-disable */
import React from 'react';
import { AccordionSection, SwatchLegendItem } from 'mapcontrols/components/subComponents';
import { DENSITY_SECTION_OBJ, LOCATION_LIST } from 'mapcontrols/constants';
import { BaseSelect } from 'ui-kit';
import * as Styled from './styles';
import { DensityLayerItem } from './DensityLayerItem';

const DensitySection = ({
  collapsedArrowIcon = '',
  expandedArrowIcon = '',
  activeSections = {},
  onSectionToggle = () => {},
  densitySelection = null,
  onDensityChange = () => {},
  onRetailerPointsToggle = () => {},
}) => {
  const currentDensitySelection = densitySelection || {
    retailerpoints: true,
    activeLayer: 'no_density',
    densityPolytype: 'county',
    swampPolytype: 'county',
  };

  const getCurrentDensityOption = () => {
    return LOCATION_LIST.find((item) => item.value === currentDensitySelection.densityPolytype) || LOCATION_LIST[0];
  };

  const getCurrentSwampOption = () => {
    return LOCATION_LIST.find((item) => item.value === currentDensitySelection.swampPolytype) || LOCATION_LIST[0];
  };

  const densityOption = getCurrentDensityOption();
  const swampOption = getCurrentSwampOption();

  const handleDensityOption = (selectedValue) => {
    onDensityChange('retailers_density', selectedValue.value);
  };

  const handleSwampOption = (selectedValue) => {
    onDensityChange('retailers_swamp', selectedValue.value);
  };

  const isLayerActive = (layerId) => {
    if (layerId === 'retailerpoints') {
      return currentDensitySelection.retailerpoints;
    }

    if (layerId === 'no_density') {
      return currentDensitySelection.activeLayer === 'no_density';
    }

    if (layerId === 'retailers_density') {
      return currentDensitySelection.activeLayer === 'retailers_density';
    }

    if (layerId === 'retailers_swamp') {
      return currentDensitySelection.activeLayer === 'retailers_swamp';
    }

    return false;
  };

  const handleDensityLayerToggle = (layerId, isChecked) => {
    if (layerId === 'retailerpoints') {
      onRetailerPointsToggle(isChecked);
    } else if (layerId === 'no_density') {
      if (isChecked) {
        onDensityChange('no_density');
      }
    } else if (layerId === 'retailers_density') {
      if (isChecked) {
        onDensityChange(layerId, currentDensitySelection.densityPolytype);
      } else {
        onDensityChange('no_density');
      }
    } else if (layerId === 'retailers_swamp') {
      if (isChecked) {
        onDensityChange(layerId, currentDensitySelection.swampPolytype);
      } else {
        onDensityChange('no_density');
      }
    }
  };

  const subPanels = {
    showDensity: {
      title: (
        <>
          <Styled.TitleSelectionWrapper>
            <BaseSelect
              name="retailers-by-density-locations"
              options={LOCATION_LIST}
              value={densityOption}
              onChange={(selectedValue) => handleDensityOption(selectedValue)}
              inputId="retailers-by-density-locations"
              className="retailers-by-density-locations"
            />
          </Styled.TitleSelectionWrapper>
        </>
      ),
      legends: (
        <>
          <Styled.SwatchLegendSection>
            <Styled.SwatchLegendWrapper>
              <SwatchLegendItem backgroundColor="red" borderColor="#000000" type="square" />
              <span>2.1 and higher retailers per 1,000 population</span>
            </Styled.SwatchLegendWrapper>
            <Styled.SwatchLegendWrapper>
              <SwatchLegendItem backgroundColor="orange" borderColor="#000000" type="square" />
              <span>1.5-2.0</span>
            </Styled.SwatchLegendWrapper>
            <Styled.SwatchLegendWrapper>
              <SwatchLegendItem backgroundColor="lemonChiffon" borderColor="#000000" type="square" />
              <span>1.1-1.4</span>
            </Styled.SwatchLegendWrapper>
            <Styled.SwatchLegendWrapper>
              <SwatchLegendItem backgroundColor="lightBlue" borderColor="#000000" type="square" />
              <span>0.6-1.0</span>
            </Styled.SwatchLegendWrapper>
            <Styled.SwatchLegendWrapper>
              <SwatchLegendItem backgroundColor="dodgerBlue" borderColor="#000000" type="square" />
              <span>Under 0.6</span>
            </Styled.SwatchLegendWrapper>
            <Styled.SwatchLegendWrapper>
              <SwatchLegendItem
                style={{
                  backgroundImage: `
    linear-gradient(45deg, #ccc 25%, transparent 25%),
    linear-gradient(-45deg, #ccc 25%, transparent 25%),
    linear-gradient(45deg, transparent 75%, #ccc 75%),
    linear-gradient(-45deg, transparent 75%, #ccc 75%),
    linear-gradient(45deg, #eee 25%, transparent 25%),
    linear-gradient(-45deg, #eee 25%, transparent 25%),
    linear-gradient(45deg, transparent 75%, #eee 75%),
    linear-gradient(-45deg, transparent 75%, #eee 75%)
  `,
                  backgroundSize: '6px 6px',
                  backgroundPosition: '0 0, 0 3px, 3px -3px, -3px 0px, 1px 1px, 1px 4px, 4px -2px, -2px 1px',
                }}
                type="square"
              />
              <span>No retailers</span>
            </Styled.SwatchLegendWrapper>
          </Styled.SwatchLegendSection>
        </>
      ),
    },
    showSwamp: {
      title: (
        <>
          <Styled.TitleSelectionWrapper>
            <BaseSelect
              name="retailers-by-swamps-locations"
              options={LOCATION_LIST}
              value={swampOption}
              onChange={(selectedValue) => handleSwampOption(selectedValue)}
              inputId="retailers-by-swamps-locations"
              className="retailers-by-swamps-locations"
            />
          </Styled.TitleSelectionWrapper>
        </>
      ),
      legends: (
        <>
          <Styled.SwatchLegendSection>
            <Styled.SwatchLegendWrapper>
              <SwatchLegendItem backgroundColor="SaddleBrown" borderColor="#000000" type="square" />
              <span>Swamp, 3 or more retailers per 1,000 population</span>
            </Styled.SwatchLegendWrapper>
            <Styled.SwatchLegendWrapper>
              <SwatchLegendItem backgroundColor="whiteSmoke" borderColor="#000000" type="square" />
              <span>Not swamp</span>
            </Styled.SwatchLegendWrapper>
            <Styled.SwatchLegendWrapper>
              <SwatchLegendItem
                style={{
                  backgroundImage: `
    linear-gradient(45deg, #ccc 25%, transparent 25%),
    linear-gradient(-45deg, #ccc 25%, transparent 25%),
    linear-gradient(45deg, transparent 75%, #ccc 75%),
    linear-gradient(-45deg, transparent 75%, #ccc 75%),
    linear-gradient(45deg, #eee 25%, transparent 25%),
    linear-gradient(-45deg, #eee 25%, transparent 25%),
    linear-gradient(45deg, transparent 75%, #eee 75%),
    linear-gradient(-45deg, transparent 75%, #eee 75%)
  `,
                  backgroundSize: '6px 6px',
                  backgroundPosition: '0 0, 0 3px, 3px -3px, -3px 0px, 1px 1px, 1px 4px, 4px -2px, -2px 1px',
                }}
                type="square"
              />
              <span>No retailers</span>
            </Styled.SwatchLegendWrapper>
          </Styled.SwatchLegendSection>
        </>
      ),
    },
  };

  return (
    <AccordionSection
      title="Density"
      id="density"
      activeSections={activeSections}
      onSectionToggle={onSectionToggle}
      collapsedArrowIcon={collapsedArrowIcon}
      expandedArrowIcon={expandedArrowIcon}
    >
      {DENSITY_SECTION_OBJ.map((item) => (
        <DensityLayerItem
          key={item.id}
          layerId={item.id}
          label={item.label}
          stackingOrder={item.stackingOrder}
          swatchStyle={item?.swatchStyle}
          isActive={isLayerActive(item.id)}
          onToggle={handleDensityLayerToggle}
          inputType={item.inputType}
          type={item.type}
          subpanel={subPanels?.[item.subpanel]?.legends}
        >
          {subPanels?.[item.subpanel]?.title}
        </DensityLayerItem>
      ))}
    </AccordionSection>
  );
};

export default DensitySection;
